import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'

import '../node_modules/material-design-icons/iconfont/material-icons.css'

const CheckEligibilityFullView = () => import(/* webpackChunkName: "CheckEligibilityFullView" */ '@/components/full/CheckEligibilityFullView')
const CheckEligibilityLiteView = () => import(/* webpackChunkName: "CheckEligibilityLiteView" */ '@/components/lite/CheckEligibilityLiteView')

const EligibilityProfileView = () => import(/* webpackChunkName: "EligibilityProfileView" */ '@/components/views/ProfileView')
const EligibilityChargesView = () => import(/* webpackChunkName: "EligibilityChargeView" */ '@/components/views/ChargesView')
const EligibilityResultsView = () => import(/* webpackChunkName: "EligibilityResultsView" */ '@/components/views/ResultsView')
const EligibilityHelpView = () => import(/* webpackChunkName: "EligibilityHelpView" */ '@/components/views/FindHelpView')

const SelfHelpView = () => import(/* webpackChunkName: "SelfHelpView" */ '@/components/views/SelfHelpView')

const appStore = {
  debug: true,
  liteEnv: null,
  CheckEligibilityView: null,
  EligibilityProfile: null,
  EligibilityCharges: null,
  EligibilityResults: null,
  ConsumerHelpView: null,
  PrepareMyApplicationView: null,
  state: {
    CompletedLearn: false,
    CompletedEligibility: false,
    SEEligible: false,
    ConsumerEligible: false,
    ConsumerEligibleNotes: '',
    CompletedTalkingAboutSE: false,
    SEProfile: {}
  },
  setCompletedLearn () {
    this.state.CompletedLearn = true
  },
  clearCompletedLearn () {
    this.state.CompletedLearn = false
  },
  getCompletedLearn () {
    return this.state.CompletedLearn
  },
  setCompletedEligibility () {
    this.state.CompletedEligibility = true
  },
  clearCompletedEligibility () {
    this.state.CompletedEligibility = false
  },
  getCompletedEligibility () {
    return this.state.CompletedEligibility
  },
  setSEEligible () {
    this.state.SEEligible = true
  },
  clearSEEligible () {
    this.state.SEEligible = false
  },
  getSEEligible () {
    return this.state.SEEligible
  },
  setConsumerEligible () {
    this.state.ConsumerEligible = true
  },
  clearConsumerEligible () {
    this.state.ConsumerEligible = false
  },
  getConsumerEligible () {
    return this.state.ConsumerEligible
  },
  setCompletedTalkingAboutSE () {
    this.state.TalkingAboutSE = true
  },
  clearCompletedTalkingAboutSE () {
    this.state.TalkingAboutSE = false
  },
  getCompletedTalkingAboutSE () {
    return this.state.TalkingAboutSE
  },
  getConsumerEligibleNotes () {
    return this.state.ConsumerEligibleNotes
  },
  getSeProfile () {
    return this.state.SEProfile
  }
}

Vue.use(Router)

const scrollHandler = (to, from, savedPosition) => {
  if (to.name) {
    return { selector: '#'.concat(to.name) }
  }
}

const createEmptyRouter = () => new Router({
  mode: 'history',
  routes: [],
  scrollBehavior: scrollHandler
})

const router = createEmptyRouter()

Vue.config.productionTip = false

// Global event bus
Vue.prototype.$eventHub = new Vue()

new Vue({
  router,
  data: appStore,
  methods: {
    handleCompletedLearn: function () {
      this.setCompletedLearn()
    },

    handleCompletedEligibility: function (EligibilityResult) {
      this.setCompletedEligibility()

      if (EligibilityResult.isEligible) {
        this.setSEEligible()
      } else {
        this.clearSEEligible()
      }

      this.state.SEProfile.isJuvenile = EligibilityResult.isJuvenile
      this.state.SEProfile.isEarlyEligible = EligibilityResult.isEarlyEligible
      this.state.SEProfile.completedDiversion = EligibilityResult.completedDiversion
      this.state.SEProfile.notes = EligibilityResult.notes
    },

    handleCompletedTalkingAboutSE: function () {
      this.setCompletedTalkingAboutSE()
    },

    handleConsumerEligibility: function (ConsumerEligibilityResult) {
      // {result: this.ConsumerIssueResult, notes: ConsumerIssueNotes}
      this.state.ConsumerEligibleNotes = ConsumerEligibilityResult.notes

      if (ConsumerEligibilityResult.result) {
        this.setConsumerEligible()
      } else {
        this.clearConsumerEligible()
      }
    }
  },
  beforeCreate: function () {
    if (window.innerWidth > 600) {
      this.liteEnv = false

      this.CheckEligibilityView = CheckEligibilityFullView
      this.EligibilityProfile = CheckEligibilityFullView
      this.EligibilityCharges = CheckEligibilityFullView
      this.EligibilityResults = CheckEligibilityFullView
      this.EligibilityHelp = CheckEligibilityFullView
      this.SelfHelp = SelfHelpView
    } else {
      this.liteEnv = true

      this.CheckEligibilityView = CheckEligibilityLiteView
      this.EligibilityProfile = EligibilityProfileView
      this.EligibilityCharges = EligibilityChargesView
      this.EligibilityResults = EligibilityResultsView
      this.EligibilityHelp = EligibilityHelpView
      this.SelfHelp = SelfHelpView
    }

    this.$router.addRoutes([{
      path: '/',
      name: 'CheckEligibility',
      component: this.CheckEligibilityView,
      children: [
        {
          path: 'profile',
          component: this.EligibilityProfile,
          name: 'EligibilityProfile'
        },
        {
          path: 'charges',
          name: 'EligibilityCharges',
          component: this.EligibilityCharges
        },
        {
          path: 'results',
          name: 'EligibilityResults',
          component: this.EligibilityResults
        },
        {
          path: 'find-help',
          name: 'EligibilityHelp',
          component: this.EligibilityHelp
        }
      ]
    },
    {
      path: '/self-help',
      name: 'SelfHelp',
      component: this.SelfHelp
    }])
  },
  created: function () {
    this.$eventHub.$on('completedLearn', this.handleCompletedLearn)
    this.$eventHub.$on('completedEligibility', this.handleCompletedEligibility)
    this.$eventHub.$on('completedConsumerEligibility', this.handleConsumerEligibility)
    this.$eventHub.$on('completedTalkingAboutSE', this.handleCompletedTalkingAboutSE)
  },
  render: h => h(App)
}).$mount('#app')
